var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4697 0.469731C12.7626 0.176838 13.2373 0.176838 13.5302 0.469731C13.8231 0.762624 13.8231 1.23738 13.5302 1.53028L6.99994 8.06055L0.46967 1.53028C0.176777 1.23738 0.176777 0.762624 0.46967 0.469731C0.762563 0.176838 1.23732 0.176838 1.53022 0.469731L6.99994 5.93946L12.4697 0.469731Z",
    fill: "#25CB8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownIcon);
export default __webpack_public_path__ + "static/media/dropDownIcon.a297cac9731dcb41be84eabca4747ed0.svg";
export { ForwardRef as ReactComponent };